/* v8 ignore start */
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieVisualLayerModel} from "@/lib/lottie/layers/lottieVisualLayerModel";

export class LottieSolidColorLayerModel extends LottieVisualLayerModel<LottieSolidColorLayerModel.IJson> {
  public get solidColor(): string {
    return this.json.sc;
  }

  public get width(): number {
    return this.json.sw;
  }

  public get height(): number {
    return this.json.sh;
  }

  public changeSolidColor(solidColor: string): this {
    return this.update({sc: solidColor});
  }

  public changeOpacity(opacity: number): this {
    return this.update({ks: this.transform.changeOpacity(opacity).toObject()});
  }
}

export namespace LottieSolidColorLayerModel {
  export interface IJson extends LottieVisualLayerModel.IJson {
    /**
     * Layer type
     * @default 1
     */
    ty: LottieLayerType.SolidColor;

    /**
     * Color of the layer, unlike most other places, the color is a `#rrggbb` hex string
     * @default ""
     */
    sc: string;

    /**
     * Width of the layer
     */
    sw: number;

    /**
     * Height of the layer
     */
    sh: number;
  }
}
/* v8 ignore stop */
